import StyledLink from '../StyledLink'
import {
  SETTINGS,
  SYSTEM
} from '../routes'
import type { Props } from '../types'

const base = '/' + SYSTEM + '/' + SETTINGS

const LinkToSettings = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={base}
  >
    {children}
  </StyledLink>

export default LinkToSettings
